import { useEffect, useRef, useState } from 'react';
import { css } from 'styled-components';

export function sharedTransition(properties, duration = '0.3s') {
  return css`
    transition: ${duration} ease;
    transition-property: ${properties};
  `;
}

export function useAnimateSection(ref) {
  const [isIntersecting, setInterescting] = useState(false);
  useEffect(() => {
    const { innerWidth } = window;
    const thresholdValue = innerWidth < 768 ? 0 : 0.4;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setInterescting(true);
          }
        });
      },
      { threshold: thresholdValue }
    );
    observer.observe(ref.current);
    return () => {
      observer.disconnect();
    };
  }, [ref]);
  return isIntersecting;
}

/**
 *
 * @param {{ComponentName: StyledComponent, ...props: any}} component
 * @returns Animated component with `$isVisible`
 */
export const AnimatedSection = ({ ComponentName, ...props }) => {
  const ref = useRef();
  const isVisible = useAnimateSection(ref);
  return <ComponentName {...props} $isVisible={isVisible} ref={ref} />;
};
